import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PageMypageComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public user: any = {};
    public tab: string = 'profile';

    // 비밀번호 변경
    public pw: any = { current: '', new: '', confirm: '' };

    public async ngOnInit() {
        await this.service.init();
        await this.loadProfile();
        await this.service.render();
    }

    public async loadProfile() {
        let { code, data } = await wiz.call("profile");
        if (code == 200) {
            this.user = data;
        }
    }

    public async changeTab(tab: string) {
        this.tab = tab;
        await this.service.render();
    }

    public async updateProfile() {
        let { code, data } = await wiz.call("update_profile", {
            name: this.user.name,
            department: this.user.department || '',
            mobile: this.user.mobile || ''
        });

        if (code == 200) {
            await this.service.modal.show({
                title: '',
                message: '프로필이 수정되었습니다.',
                cancel: false,
                actionBtn: 'success',
                action: '확인',
                status: 'success'
            });
            await this.loadProfile();
            await this.service.render();
        } else {
            await this.service.modal.show({
                title: '',
                message: data.message || '프로필 수정에 실패했습니다.',
                cancel: false,
                actionBtn: 'error',
                action: '확인',
                status: 'error'
            });
        }
    }

    public async changePassword() {
        if (!this.pw.current || !this.pw.new || !this.pw.confirm) {
            await this.service.modal.show({
                title: '',
                message: '모든 항목을 입력해주세요.',
                cancel: false,
                actionBtn: 'error',
                action: '확인',
                status: 'error'
            });
            return;
        }

        if (this.pw.new !== this.pw.confirm) {
            await this.service.modal.show({
                title: '',
                message: '새 비밀번호가 일치하지 않습니다.',
                cancel: false,
                actionBtn: 'error',
                action: '확인',
                status: 'error'
            });
            return;
        }

        if (this.pw.new.length < 6) {
            await this.service.modal.show({
                title: '',
                message: '비밀번호는 6자 이상이어야 합니다.',
                cancel: false,
                actionBtn: 'error',
                action: '확인',
                status: 'error'
            });
            return;
        }

        let { code, data } = await wiz.call("change_password", {
            current_password: this.pw.current,
            new_password: this.pw.new
        });

        if (code == 200) {
            this.pw = { current: '', new: '', confirm: '' };
            await this.service.modal.show({
                title: '',
                message: '비밀번호가 변경되었습니다.',
                cancel: false,
                actionBtn: 'success',
                action: '확인',
                status: 'success'
            });
            await this.service.render();
        } else {
            await this.service.modal.show({
                title: '',
                message: data.message || '비밀번호 변경에 실패했습니다.',
                cancel: false,
                actionBtn: 'error',
                action: '확인',
                status: 'error'
            });
        }
    }

    public logout() {
        location.href = '/auth/logout';
    }
}

export default PageMypageComponent;